// Select all buttons inside the team section
const btn_members = document.querySelectorAll('section.team button')

// Select the dialog element for the member
const member_dialog = document.querySelector(
    'dialog.member'
) as HTMLDialogElement

const memberHandler = (btn: HTMLButtonElement) => {
    // Get the data attributes from the button
    const name = btn.getAttribute('data-name')
    const headshot = btn.getAttribute('data-headshot')
    const specialties = JSON.parse(btn.getAttribute('data-specialties') || '[]')
    // const booksy_link = btn.getAttribute('data-booksy-link')
    const instagram_name = btn.getAttribute('data-instagram-name')
    const tiktok_name = btn.getAttribute('data-tiktok-name')

    // Start building the HTML for the dialog
    let elementHTML: string = '<div class="container">'
    elementHTML +=
        '<button type="button" class="close"><i class="fi fi-sr-cross"></i></button>'

    elementHTML += `<img srcset="${headshot}?fit=cover&width=360&height=450 1x, ${headshot}?fit=cover&width=720&height=900 2x, ${headshot}?fit=cover&width=1080&height=1350 3x" src="${headshot}?fit=cover&width=360&height=450" alt="${name}">`

    // Add the content div with the member name, booksy link, instagram name, and tiktok name
    elementHTML += '<div class="content">'
    elementHTML += `<h1>${name}</h1>`

    if (!!specialties) {
        elementHTML += `<ul class="specialties">`
        specialties.forEach(
            (specialty: string) =>
                (elementHTML += `<li class="specialty">${specialty}</li>`)
        )
        elementHTML += `</ul>`
    }

    // if (booksy_link || instagram_name || tiktok_name) {
    if (instagram_name || tiktok_name) {
        elementHTML += '<div class="links">'
        // elementHTML += booksy_link
        //     ? `<a href="${booksy_link}" class="booksy" target="_self" rel="noopener">Schedule <i class="fi fi-sr-calendar-clock"></i></a>`
        //     : ''
        elementHTML += instagram_name
            ? `<a href="https://instagram.com/${instagram_name}" class="social instagram" target="_blank" rel="noopener" title="Instagram Profile"><i class="fi fi-brands-instagram"></i></a>`
            : ''
        elementHTML += tiktok_name
            ? `<a href="https://tiktok.com/@${tiktok_name}" class="social tiktok" target="_blank" rel="noopener" title="TikTok Profile"><i class="fi fi-brands-tik-tok"></i></a>`
            : ''
        elementHTML += '</div>'
    }
    elementHTML += '</div>'

    // Close the container div
    elementHTML += '</div>'

    // Set the body dataset to active
    document.body.dataset.mmActive = 'true'

    // Set the dialog innerHTML to the elementHTML
    member_dialog.innerHTML = elementHTML

    // Select the close button
    const btn_close = document.querySelector(
        'button.close'
    ) as HTMLButtonElement

    // Add event listeners to the close
    btn_close.addEventListener('click', _ => closeHandler(member_dialog))

    // Show the dialog
    member_dialog.showModal()
    const container = member_dialog.querySelector('.container') as HTMLElement
    container.style.filter = 'opacity(1)'

    // Add event listener to the dialog close event
    member_dialog.addEventListener('close', _ => {
        btn_close.removeEventListener('click', _ => closeHandler(member_dialog))

        // Set the body dataset to false
        document.body.dataset.mmActive = 'false'

        // Remove the container div
        document.querySelector('div.container')?.remove()
    })
}

// Check if buttons are found
if (btn_members) {
    // Loop through each button
    btn_members.forEach(btn => {
        // Add click event listener to each item button
        btn.addEventListener('click', _ =>
            memberHandler(btn as HTMLButtonElement)
        )
    })
}

// Close the dialog when the close button is clicked
const closeHandler = (d: HTMLDialogElement) => d.close()
